export default "__VITE_ASSET__5ufzVjBH__"